import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';

const TenderMain = () => {
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedTenderId, setExpandedTenderId] = useState(null);

  useEffect(() => {
    fetch('https://ricgop.online/api/tenders.php')
      .then(res => res.json())
      .then(data => {
        setTenders(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching tenders:', err);
        setLoading(false);
      });
  }, []);

  const toggleTender = (id) => {
    setExpandedTenderId(prev => (prev === id ? null : id));
  };

  const renderTendersByCategory = (category, displayName, icon) => {
    const filtered = tenders.filter(t => t.category === category);

    if (filtered.length === 0) return null;

    return (
      <>
        <h3 className="text-dark fw-bold mb-4 mt-5">{icon} {displayName}</h3>
        <div className="row justify-content-center">
          {filtered.map((tender) => (
            <div className="col-md-10 col-lg-8 mb-4" key={tender.id}>
              <div
                className="card border-0 shadow-sm rounded-4 bg-white tender-card"
                style={{ transition: 'transform 0.3s ease', cursor: 'pointer' }}
              >
                <div
                  className="card-header bg-transparent border-bottom-0 p-4 d-flex justify-content-between align-items-center"
                  onClick={() => toggleTender(tender.id)}
                >
                  <h5 className="mb-0 fw-semibold text-primary">{tender.title}</h5>
                  <span className="fs-4 text-muted">{expandedTenderId === tender.id ? '−' : '+'}</span>
                </div>

                <div
                  className={`card-body px-4 pt-0 pb-4 ${expandedTenderId === tender.id ? 'show' : 'collapse'}`}
                  style={{
                    maxHeight: expandedTenderId === tender.id ? '500px' : '0',
                    overflow: 'hidden',
                    transition: 'max-height 0.4s ease',
                  }}
                >
                  <hr className="my-3" />
                  <p className="text-secondary">{tender.description}</p>
                  <p className="text-muted small mb-3"><strong>Posted on:</strong> {tender.posted_date}</p>
                  <a
                    href={`/assets/pdfs/${tender.pdf_filename}`}
                    download={`${tender.title.replace(/[^a-z0-9]/gi, '_')}.pdf`}
                    className="btn btn-primary rounded-pill px-4 py-2"
                  >
                    📥 Download PDF
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <main>
      <Breadcrumb title="Tenders" />
      <section className="py-5" style={{ backgroundColor: '#f9fbfc' }}>
        <div className="container">
          <h2 className="text-center mb-5 text-dark fw-bold display-5">
            📑 View All Tender Categories
          </h2>

          {loading ? (
            <p className="text-center text-secondary">Loading tenders...</p>
          ) : (
            <>
              {renderTendersByCategory('IT Equipment', 'IT Equipment Tenders', '💻')}
              {renderTendersByCategory('Other', 'Other Tenders', '📦')}
              {renderTendersByCategory('Grievances', 'Grievances & Feedback', '📬')}
            </>
          )}
        </div>

      </section>
    </main>
  );
};

export default TenderMain;
